module.exports = __webpack_public_path__ + "img/jyj_wj_welcome_2_1.0241f164.png";